import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Divider, Typography } from "@material-ui/core";
import {
    getUserDetails,
    updateHeaderInfo,
    copyDeck,
    editDeck,
    subscribeDeck,
    updateNotification,
    updateUserProfile
} from "../actions";
import { withRouter } from 'react-router-dom';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AddIcon from '@material-ui/icons/Add';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';

import { LoadingCard, CopyrightWidget, SaspButton } from "../components";
import { deviceData, getThisYear, remoteURL, setContainer } from "../common";
import { isElectron } from "react-device-detect";

//make state = initial_state
class ViewDeckScreen extends Component {
    state = {
        loading: true,
        preloading: true
    };

    componentDidMount = async () => {
        await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
        const { mcid, key } = this.props.auth_feedback;
        await this.props.getUserDetails(mcid, key);
        this.setState({ ...this.state, preloading: false })

        const item = this.props.user_details.notifications.notifications.find(i => i.pkid == this.props.location.pkid);
        
        return this.props.updateHeaderInfo({route:"/viewMessage", iconOne: 'back', name: "Message Details"});
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.user_details !== this.props.user_details) {
            document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
            this.setState({ ...this.state, loading: false});
        }

        if (prevState.preloading !== this.state.preloading) {
            if (this.state.loading) { 
                if (typeof this.props.user_details.notifications !== 'undefined') {
                    this.setState({ ...this.state, loading: false });
                } else {
                }
            }
        }
    };

    handleSendAccess = async (data) => {
        if (typeof data.bool === 'undefined') {
            data.bool = 1;
        }

        const obj = {
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            allowShare: this.props.user_details.allowshare,
            allowSearch: this.props.user_details.allowsearch,
            allowLeaderboard: this.props.user_details.allowleaderboard,
            isDaily: this.props.user_details.isDaily,
            displayName: this.props.user_details.displayname,
            yst: this.props.user_details.yst,
            tl: this.props.user_details.tl,
            isDaily: this.props.user_details.isDaily,
            allowProgram: data.bool ? 1 : 0,
            isResident: this.props.user_details.isResident,
            pkid: data.item.pkid ? data.item.pkid  : 0,
        }

        await this.props.updateUserProfile(obj);

        let target = {
            pathname: '/home'
        }
        
        return <Redirect to={target} />
    }

    createMarkup = props => {
        if (!props.includes('<p>')) { props = '<p>' + props + '</p>'}
        return { __html: props };
    };

    updateDeck = async (data) => {
        this.setState({ ...this.state, loading: true});
        let notif = {
            mcid : data.mcid,
            key : data.key,
            state : data.state,
            pkid : data.pkid
        };

        let obj = {
            mcid : data.mcid,
            key : data.key,
            deckID : data.deckId
        };

        await this.props.updateNotification(notif);
        switch(data.type) {
            case 'copy': {
                await this.props.copyDeck(obj);
                await this.props.getUserDetails(obj.mcid, obj.key);
                this.props.history.push('/myDecks');
                break;
            }
            case 'subscribe': {
                await this.props.subscribeDeck(obj);
                await this.props.getUserDetails(obj.mcid, obj.key);
                this.props.history.push('/myDecks');
                break;
            }

            case 'activate': {
                obj.isActive = 1;
                await this.props.editDeck(obj);
                await this.props.getUserDetails(obj.mcid, obj.key);
                this.props.history.push('/myDecks');
                break;
            }

            default: {
                await this.props.getUserDetails(obj.mcid, obj.key);
                this.props.history.push('/notifications');
                break;
            }
        }
    }

    getSASPLink = (year) => {
        
        return <a href={`https://cme.auanet.org/URL/SASP${year - 2000}Credit`} target="_blanks" className="color-blue"><strong>SASP {year}</strong></a>;
    }

    render = () => {
        if (!this.state.loading) {
            const item = this.props.user_details.notifications.notifications.find(i => i.pkid == this.props.location.pkid)
            
            if (typeof item !== 'undefined') {
                let uri = `https://auau.auanet.org/node/${item.notificationDetail}`;
                return (
                    <div className="aua-overflow" style={setContainer(isElectron)}>
                        <Typography className="homeDividerText">Message</Typography>

                        <div style={{margin: "0"}}>
                            <div style={{ padding: "0"}} className="anchor">
                                <div style={{ top: "-34px", right: "0px", position: "absolute" }}>
                                    <CloseIcon
                                        onClick={() => this.updateDeck({
                                            mcid: this.props.user_details.mcid,
                                            key: this.props.user_details.key,
                                            deckId: item.notificationDetail,
                                            pkid: item.pkid,
                                            state: 0,
                                            type: 'delete'
                                        })}
                                        className="text-orange"
                                        style={{ 
                                            fontSize: '1.5em',
                                            justifyContent: "flex-end",
                                            marginTop: "2px"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="aua-container">
                            <div className="flex-col-start">
                                <div className="flex-row-between width100">
                                    <div className="text-blue text-strong">From: </div>
                                    <div className="text-grey">{item.datestr}</div> 
                                </div>
                                <div className="text-light-blue margin-bottom-8">{item.from}</div>

                                {item.notificationType.includes('COMPLETED')
                                ? (
                                    <div className="width100">
                                        <p>You have answered 100% of the {item.year} SASP questions, scoring at least 50% correct, and are now eligible for up to 20 hours of CME credit.</p>

                                        <p><strong>To receive CME credit, please complete the following:</strong></p>

                                        <ol>
                                            <li>
                                                Click on the following Link: {this.getSASPLink(item.year)}
                                            </li>
                                            <ol>
                                                <li>If you are not already, log in to the AUA<em>University</em></li>
                                            </ol>
                                            <li>Click on the <strong>Evaluation</strong> tab or Go to <strong>Evaluation</strong> button</li>
                                            <li>Click on the <strong>Start</strong> button</li>
                                            <li>Complete the <strong>Course Evaluation</strong> and click <strong>submit</strong></li>
                                        </ol>     

                                        <p>To purchase other SASP years, please visit <a href="https://cme.auanet.org/Page/SASP" target="_blank" className="text-blue">AUAnet.org/SASP</a>.</p>                                   
                                    </div>
                                ) : (
                                    <div 
                                        dangerouslySetInnerHTML={this.createMarkup(item.message)}
                                    />
                                )
                                }

                                <div>
                                    <p>Thank you for participating in the SASP!</p>
                                </div>
                            </div>
                        </div>

                        {item.notificationType == 'DECK' || item.notificationType == 'MESSAGE'
                            ? (
                                <>
                                <div style={{margin: "0"}}>
                                    <div style={{ padding: "0"}}>
                                        <Divider className="SASPTestsDivider" />
                                    </div>
                                </div>
                                <div className="aua-container">
                                    <div className="flex-col-start">
                                        <div className="flex-row-between width100">
                                            {item.notificationState == 1 && item.notificationType == 'DECK'
                                                ? (
                                                    <>
                                                    <div 
                                                        className="flex-col-center text-blue"
                                                        onClick={() => this.updateDeck({
                                                            mcid: this.props.user_details.mcid,
                                                            key: this.props.user_details.key,
                                                            deckId: item.notificationDetail,
                                                            pkid: item.pkid,
                                                            state: 2,
                                                            type: 'subscribe'
                                                        })}
                                                    >
                                                        <div className="icon-widget">
                                                            <CollectionsBookmarkIcon />
                                                        </div>
                                                        <div>Subscribe</div>
                                                    </div>

                                                    <div 
                                                        className="flex-col-center text-blue"
                                                        onClick={() => this.updateDeck({
                                                            mcid: this.props.user_details.mcid,
                                                            key: this.props.user_details.key,
                                                            deckId: item.notificationDetail,
                                                            pkid: item.pkid,
                                                            state: 2,
                                                            type: 'copy'
                                                        })}
                                                    >
                                                        <div className="icon-widget">
                                                            
                                                            {item.notificationType == 'DECK'
                                                                ? (<FileCopyIcon />)
                                                                : (<AddIcon />)
                                                            }
                                                        </div>
                                                        <div>
                                                            {item.notificationType == 'DECK'
                                                                ? (<>Copy</>)
                                                                : (<>Activate</>)
                                                            }
                                                        </div>
                                                    </div>
                                                    </>
                                                )
                                                : (
                                                    <div 
                                                        className="flex-col-center text-blue"
                                                        onClick={() => this.updateDeck({
                                                            mcid: this.props.user_details.mcid,
                                                            key: this.props.user_details.key,
                                                            deckId: item.notificationDetail,
                                                            pkid: item.pkid,
                                                            state: 2,
                                                            type: 'activate'
                                                        })}
                                                    >
                                                        <div className="icon-widget">
                                                            
                                                            {item.notificationType == 'DECK'
                                                                ? (<FileCopyIcon />)
                                                                : (<AddIcon />)
                                                            }
                                                        </div>
                                                        <div>
                                                            {item.notificationType == 'DECK'
                                                                ? (<>Copy</>)
                                                                : (<>Activate</>)
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                </>
                            )
                            : null
                        }

                        {item.notificationType == 'ACCESSREQUEST'
                            ? (
                                <>
                                    <div style={{margin: "0"}}>
                                        <div style={{ padding: "0"}}>
                                            <Divider className="SASPTestsDivider" />
                                        </div>
                                    </div>

                                    <div className="aua-container">
                                        <div className="flex-col-start">
                                            <div className="flex-row-between width100">
                                                <div 
                                                    className="flex-col-center text-grey"
                                                    onClick={() => this.handleSendAccess({bool: 0, item: item})}
                                                >
                                                    <div 
                                                        className="icon-widget"
                                                        style={{
                                                            color: 'env(--aua-theme-color-grey)',
                                                            backgroundColor: 'white'
                                                        }}
                                                    >
                                                        <CloseIcon />
                                                    </div>
                                                    <div>
                                                        No
                                                    </div>
                                                </div>

                                                <div 
                                                    className="flex-col-center text-blue"
                                                    onClick={() => this.handleSendAccess({bool: 1, item: item})}
                                                >
                                                    <div className="icon-widget">
                                                        <AddIcon />
                                                    </div>
                                                    <div>
                                                        Yes
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null
                        }

                        <CopyrightWidget 
                            begin={2021}
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-48 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />                
                    </div>
                )
            } else {
                return (
                    <div
                        style={{
                            width: "66vw",
                            height: "66vh",
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            padding: "16px"
                        }}
                    >
                        <div className="flex-col-start width100">
                            <div className="margin-bottom-8 margin-top-8">
                                <Typography className="homeDividerText">Message</Typography>
                                <Divider className="SASPTestsDivider" />
                            </div>
                            <div className="margin-bottom-8">No notification found.</div>
                            <Link 
                                to={{
                                    pathname: "/notifications",
                                }}
                                className="text-blue"
                            >
                                Return to Inbox
                            </Link>
                            
                        </div>

                        <CopyrightWidget 
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-48 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                )
            }
        } else {
            return ( <LoadingCard /> )
        }
    }
}

const mapStateToProps = state => {
    const { user_details, auth_feedback } = state.auth;
    const { newDeckInfo, publicDecks, copyDeckInfo } = state.decks;
    const { available_questions, get_question_count, question, get_question_results } = state.question;
    return { 
        user_details, 
        auth_feedback, 
        available_questions, 
        newDeckInfo, 
        get_question_count,
        question, 
        get_question_results,
        publicDecks,
        copyDeckInfo
    };
};

export default connect(mapStateToProps, {
    getUserDetails,
    updateHeaderInfo,
    copyDeck,
    editDeck,
    subscribeDeck,
    updateNotification,
    updateUserProfile
})(withRouter(ViewDeckScreen));
